import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 2,
  class: "product-img w-100 mx-3 mb-3"
}
const _hoisted_3 = { class: "wc-promo-ribbon-wrap" }
const _hoisted_4 = { class: "wc-promo-ribbon-wrap" }
const _hoisted_5 = {
  key: 1,
  class: "row align-items-center w-100 m-0 p-0"
}
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = { class: "row justify-content-center" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = {
  key: 0,
  class: "text-center text-danger text-small"
}
const _hoisted_10 = { class: "font-weight-bold text-center" }
const _hoisted_11 = {
  key: 0,
  class: "alternate-name"
}
const _hoisted_12 = { class: "text-center font-weight-bold" }
const _hoisted_13 = { class: "row mx-auto w-100 p-0 m-0" }
const _hoisted_14 = { class: "w-50 px-1 fit-content" }
const _hoisted_15 = { class: "wc-promo-ribbon-wrap" }
const _hoisted_16 = { class: "row w-100 px-2 m-0" }
const _hoisted_17 = {
  key: 0,
  class: "my-3 mx-auto px-1 col"
}
const _hoisted_18 = {
  key: 1,
  class: "mx-auto w-100 px-1 text-center"
}
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = { class: "mr-3" }
const _hoisted_21 = {
  key: 2,
  class: "col-12"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["aria-label"]
const _hoisted_24 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WCMobileSubpageHeader = _resolveComponent("WCMobileSubpageHeader")!
  const _component_WCImageWithShadow = _resolveComponent("WCImageWithShadow")!
  const _component_WCPromoRibbon = _resolveComponent("WCPromoRibbon")!
  const _component_SplideSlide = _resolveComponent("SplideSlide")!
  const _component_Splide = _resolveComponent("Splide")!
  const _component_WCCarousel = _resolveComponent("WCCarousel")!
  const _component_WCProductNameMobile = _resolveComponent("WCProductNameMobile")!
  const _component_WCProductPricing = _resolveComponent("WCProductPricing")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WCProductDetailsImage = _resolveComponent("WCProductDetailsImage")!
  const _component_WCRestrictedItemRibbon = _resolveComponent("WCRestrictedItemRibbon")!
  const _component_WCAddToListButtonMobile = _resolveComponent("WCAddToListButtonMobile")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_WCBasicAddToCartButton = _resolveComponent("WCBasicAddToCartButton")!
  const _component_WCProductDetailsMobile = _resolveComponent("WCProductDetailsMobile")!
  const _component_WCAlternateItems = _resolveComponent("WCAlternateItems")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'wc-page-wrapper': !_ctx.scanMode, 'wc-scan-wrapper container': _ctx.scanMode })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["row", { 'm-0 p-0': _ctx.scanMode }])
    }, [
      (_ctx.item && (!_ctx.scanMode || _ctx.isScanModePDP))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_WCMobileSubpageHeader, {
                  key: 0,
                  title: _ctx.$route.meta.title ? _ctx.$route.meta.title : _ctx.$route.name
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _cache[7] || (_cache[7] = _createTextVNode()),
            (_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1))
              : _createCommentVNode("", true),
            _cache[8] || (_cache[8] = _createTextVNode()),
            (_ctx.item.images && _ctx.item.images.length === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_WCImageWithShadow, {
                    imageSrc: _ctx.itemImageSrc(_ctx.item.images[0]),
                    alt: _ctx.productImgAltText(_ctx.item.name, _ctx.item.brand),
                    class: "wc-img--full-size",
                    defaultTitle: _ctx.noProductImageAltText(_ctx.item.name)
                  }, null, 8, ["imageSrc", "alt", "defaultTitle"]),
                  _cache[4] || (_cache[4] = _createTextVNode()),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_WCPromoRibbon, {
                      product: _ctx.item,
                      ribbonType: _ctx.promoRibbonType.SALE_AMOUNT_RIBBON
                    }, null, 8, ["product", "ribbonType"]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createVNode(_component_WCPromoRibbon, {
                      product: _ctx.item,
                      ribbonType: _ctx.promoRibbonType.DISCOUNT_NAME_RIBBON
                    }, null, 8, ["product", "ribbonType"])
                  ])
                ]))
              : (_ctx.item.images && _ctx.item.images.length > 1)
                ? (_openBlock(), _createBlock(_component_WCCarousel, {
                    key: 3,
                    class: "wc-carousel--negate-padding py-2 d-flex mx-2 w-100",
                    isSlider: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Splide, {
                        options: {
              type: 'slide',
              pagination: true,
              arrows: false,
              gap: '1rem',
            },
                        class: "container-fluid pb-4",
                        role: "list"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.images, (image) => {
                            return (_openBlock(), _createBlock(_component_SplideSlide, {
                              key: image.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_WCImageWithShadow, {
                                  imageSrc: _ctx.itemImageSrc(image),
                                  alt: _ctx.productImgAltText(_ctx.item.name, _ctx.item.brand),
                                  class: "wc-img--full-size",
                                  defaultTitle: _ctx.noProductImageAltText(_ctx.item.name)
                                }, null, 8, ["imageSrc", "alt", "defaultTitle"]),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_4, [
                                  _createVNode(_component_WCPromoRibbon, {
                                    product: _ctx.item,
                                    ribbonType: _ctx.promoRibbonType.SALE_AMOUNT_RIBBON
                                  }, null, 8, ["product", "ribbonType"]),
                                  _cache[5] || (_cache[5] = _createTextVNode()),
                                  _createVNode(_component_WCPromoRibbon, {
                                    product: _ctx.item,
                                    ribbonType: _ctx.promoRibbonType.DISCOUNT_NAME_RIBBON
                                  }, null, 8, ["product", "ribbonType"])
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
            _cache[9] || (_cache[9] = _createTextVNode()),
            _createVNode(_component_WCProductNameMobile, {
              class: "m-3",
              item: _ctx.item
            }, null, 8, ["item"]),
            _cache[10] || (_cache[10] = _createTextVNode()),
            (!_ctx.shouldHideItemPrices)
              ? (_openBlock(), _createBlock(_component_WCProductPricing, {
                  key: 4,
                  item: _ctx.item,
                  embeddedPrice: _ctx.priceEmbeddedLineItem ? _ctx.priceEmbeddedLineItem.embeddedPrice : null,
                  class: "text-right col-10"
                }, null, 8, ["item", "embeddedPrice"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_ctx.item && _ctx.scanMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: { path: `/i/${_ctx.item.id}`, query: { scan: _ctx.scanMode } }
                    }, {
                      default: _withCtx(() => [
                        (_ctx.itemNotInList)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('notOnYourList')), 1))
                          : _createCommentVNode("", true),
                        _cache[11] || (_cache[11] = _createTextVNode()),
                        _createElementVNode("h2", _hoisted_10, [
                          _createTextVNode(_toDisplayString(_ctx.item.name), 1),
                          (_ctx.item.alternateName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "\n                    - " + _toDisplayString(_ctx.item.alternateName), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.item.brand), 1)
                  ])
                ])
              ]),
              _cache[17] || (_cache[17] = _createTextVNode()),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  class: "unstyled-btn w-50 px-1",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('handleProductView')))
                }, [
                  _createVNode(_component_WCProductDetailsImage, {
                    item: _ctx.item,
                    scanMode: true
                  }, null, 8, ["item"])
                ]),
                _cache[14] || (_cache[14] = _createTextVNode()),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_WCProductPricing, {
                    class: "price-text-size",
                    item: _ctx.item,
                    embeddedPrice: _ctx.priceEmbeddedLineItem ? _ctx.priceEmbeddedLineItem.embeddedPrice : null,
                    isScanMode: true
                  }, null, 8, ["item", "embeddedPrice"]),
                  _cache[13] || (_cache[13] = _createTextVNode()),
                  _createElementVNode("div", _hoisted_15, [
                    (
                  _ctx.scanMode &&
                    (_ctx.item.hasTimeRestrictions ||
                      _ctx.item.cashierApprovalRequired ||
                      _ctx.item.hasAgeRestriction ||
                      (_ctx.item.hasRestriction && !_ctx.item.excludeFromCombos) ||
                      (!_ctx.priceEmbeddedLineItem && _ctx.item.weightProfile))
                )
                      ? (_openBlock(), _createBlock(_component_WCRestrictedItemRibbon, {
                          key: 0,
                          class: "mb-1 wc-red-ribbon",
                          item: _ctx.item
                        }, null, 8, ["item"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _cache[18] || (_cache[18] = _createTextVNode()),
              _createElementVNode("div", _hoisted_16, [
                (_ctx.isScanAddToListButtonEnabled && !_ctx.priceEmbeddedLineItem)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (!_ctx.item.hasModifiers && !_ctx.item.hasLinkedItems)
                        ? (_openBlock(), _createBlock(_component_WCAddToListButtonMobile, {
                            key: 0,
                            class: "w-100",
                            item: _ctx.item,
                            showText: true
                          }, null, 8, ["item"]))
                        : (
                (_ctx.item.hasModifiers ||
                  _ctx.item.hasLinkedItems ||
                  (_ctx.item.hasModifiers && !_ctx.$configuration.cartEnabled) ||
                  (_ctx.item.hasLinkedItems && !_ctx.$configuration.cartEnabled)) &&
                  !_ctx.priceEmbeddedLineItem
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("button", {
                                class: "btn btn-outline-primary w-100",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.customizeItemToAddToList(true))),
                                ref: "customizeBtnRef",
                                "aria-label": _ctx.$t('customizeAndAddToList')
                              }, [
                                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('customizeAndAddToList')), 1),
                                _cache[15] || (_cache[15] = _createTextVNode()),
                                _createVNode(_component_font_awesome_icon, { icon: "list-check" })
                              ], 8, _hoisted_19)
                            ]))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _cache[16] || (_cache[16] = _createTextVNode()),
                (_ctx.isScanAddToCartButtonEnabled)
                  ? (_openBlock(), _createBlock(_component_WCBasicAddToCartButton, {
                      key: 1,
                      class: "my-3 mx-auto px-1 col",
                      showMobileCustomize: true,
                      item: _ctx.item,
                      priceEmbeddedLineItem: _ctx.priceEmbeddedLineItem,
                      orderType: !_ctx.isScanAndGoMode ? _ctx.activeOrderType : null
                    }, null, 8, ["item", "priceEmbeddedLineItem", "orderType"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
      _cache[22] || (_cache[22] = _createTextVNode()),
      (!_ctx.scanMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            (!_ctx.shouldHideItemPrices)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["row mx-auto", {
            'justify-content-between': !_ctx.isGuest,
            'justify-content-center': _ctx.isGuest,
          }])
                }, [
                  _createVNode(_component_WCBasicAddToCartButton, {
                    showMobileCustomize: true,
                    item: _ctx.item,
                    class: "btn-block col-sm-6 col-9 p-0 mr-auto",
                    showAddToCartOption: _ctx.showAddToCartButton,
                    orderType: !_ctx.isScanAndGoMode ? _ctx.activeOrderType : null
                  }, null, 8, ["item", "showAddToCartOption", "orderType"]),
                  _cache[19] || (_cache[19] = _createTextVNode()),
                  (!_ctx.isItemListOnly(_ctx.item))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (
                (!_ctx.item.hasModifiers && !_ctx.item.hasLinkedItems) ||
                  (!_ctx.item.hasModifiers && !_ctx.item.hasLinkedItems && !_ctx.$configuration.cartEnabled)
              )
                          ? (_openBlock(), _createBlock(_component_WCAddToListButtonMobile, {
                              key: 0,
                              class: "ml-auto",
                              item: _ctx.item,
                              isGuest: _ctx.isGuest
                            }, null, 8, ["item", "isGuest"]))
                          : (
                _ctx.item.hasModifiers ||
                  _ctx.item.hasLinkedItems ||
                  (_ctx.item.hasModifiers && !_ctx.$configuration.cartEnabled) ||
                  (_ctx.item.hasLinkedItems && !_ctx.$configuration.cartEnabled)
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("button", {
                                  class: "btn btn-outline-primary ml-2",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.customizeItemToAddToList(true))),
                                  ref: "customizeBtnRef",
                                  "aria-label": _ctx.$t('customizeAndAddToList')
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "list-check" })
                                ], 8, _hoisted_23)
                              ]))
                            : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_router_link, {
                    class: "btn btn-primary btn-block wc-atc-btn wc-atc-btn--basic",
                    to: "/login"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('signInToShop')), 1)
                    ]),
                    _: 1
                  })
                ])),
            _cache[20] || (_cache[20] = _createTextVNode()),
            (!_ctx.scanMode)
              ? (_openBlock(), _createBlock(_component_WCProductDetailsMobile, {
                  key: 2,
                  class: "mt-3 mb-3",
                  item: _ctx.item
                }, null, 8, ["item"]))
              : _createCommentVNode("", true),
            _cache[21] || (_cache[21] = _createTextVNode()),
            (!_ctx.scanMode)
              ? (_openBlock(), _createBlock(_component_WCAlternateItems, {
                  key: 3,
                  item: _ctx.item,
                  showAddToCartButton: !_ctx.isScanAndGoMode
                }, null, 8, ["item", "showAddToCartButton"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}